<div class="lvi-content">
    <div class="avatar">
        <span>{{ data.code }}</span>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a [routerLink]="" (click)="extraOptions.close(data)">{{ data.libelle }}</a>
        </div>
    </div>
</div>